export default "__VITE_ASSET__CrgPprjx__"